import * as React from 'react';
import { Button, FlexRow, Icon, IconSize, IconType } from 'ui-toolkit';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';

interface IScheduleAButtonBlock {
  policyType: PolicyTypeEnum;
  additionalText?: string;
  showFetching: boolean;
  showSuccess: boolean;
  disableButton: boolean;
  goNext: () => void;
  goBack: () => void;
}

const ScheduleAButtonBlock: React.FunctionComponent<IScheduleAButtonBlock> = (props) => {
  return props.policyType !== PolicyTypeEnum.shortForm ? (
    <FlexRow justifyContent={'flex-end'}>
      {props.additionalText ? <span>{props.additionalText}</span> : null}
      {props.showSuccess ? <Icon type={IconType.Check} size={IconSize.Small} /> : null}
      <Button intent="primary" disabled={props.disableButton ? true : false} onClick={props.goNext}>
        Next
      </Button>
    </FlexRow>
  ) : null;
};

export default ScheduleAButtonBlock;
